import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { IPaginatedResponse } from '@boma/client-shared';
import { IListing } from 'libs/supplier-portal/shared/entities/src/lib/shared-entities';

@Injectable({
  providedIn: 'root',
})
export class ListingsService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  loadListings(
    entityId: string = '',
    locationId: string = '',
    type: string = 'Buying',
    page: string = '1',
    perPage: string = '150'
  ) {
    //removed locationId from the parameters as they break the API by being empty
    const bodyParams = {};

    if (locationId) bodyParams['locationId'] = locationId;

    bodyParams['type'] = type;
    bodyParams['page'] = page;
    bodyParams['perPage'] = perPage;

    return this.httpClient.get<IPaginatedResponse<IListing>>(
      `${this.base}api/v${this.version}/InformalListings/${entityId}`,
      {
        params: bodyParams,
      }
    );
  }

  loadSellerListings(
    entityId: string = '',
    locationId: string = '',
    type: string = 'Selling',
    page: string = '1',
    perPage: string = '150'
  ) {
    //removed locationId from the parameters as they break the API by being empty
    let bodyParams = {};

    if (locationId !== '') bodyParams['locationId'] = locationId;

    bodyParams['type'] = type;
    bodyParams['page'] = page;
    bodyParams['perPage'] = perPage;

    return this.httpClient.get<IPaginatedResponse<IListing>>(
      `${this.base}api/v${this.version}/InformalListings/${entityId}/`,
      {
        params: bodyParams,
      }
    );
  }

  loadListing(entityId: string, id: string) {
    return this.httpClient.get<IListing>(
      `${this.base}api/v${this.version}/InformalListings/${entityId}/InformalListings/${id}`
    );
  }

  createListing(entityId: string, listing: IListing) {
    return this.httpClient.post<IListing>(
      `${this.base}api/v${this.version}/InformalListings/${entityId}`,
      {
        ...listing,
      }
    );
  }

  updateListing(entityId: string, listingId: string, listing: IListing) {
    console.log(entityId, listingId, listing);
    return this.httpClient.put<IListing>(
      `${this.base}api/v${this.version}/InformalListings/${entityId}/${listingId}`,
      {
        ...listing,
      }
    );
  }

  // Once this enpoint is triggered it will create an order between the buyer and the seller
  acceptListing(
    entityId: string,
    sellerId: string,
    receivingLocationId: string,
    listingId: string,
    comment: string
  ) {
    console.log('entityid:', entityId);
    return this.httpClient.post<IListing>(
      `${this.base}api/v${this.version}/InformalListings/${entityId}/AcceptListing?sellerId=${sellerId}`,
      {
        receivingLocationId: receivingLocationId,
        listingId: listingId,
        comment: comment,
      }
    );
  }
}
